export function emailValidation(email: string): boolean {
  const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email).toLowerCase());
}

export function getQueryParams(str: string) {
  return str
    .split("&")
    .map((str) => str.split("="))
    .reduce((acc: { [key: string]: string }, [key, value], index) => {
      const v = decodeURIComponent(value);
      if (key[0] == "?") {
        acc[key.substring(1)] = v;
      } else {
        acc[key] = v;
      }
      return acc;
    }, {});
}

export function removeQueryParams(path: string) {
  window.history.replaceState({}, document.title, path);
}

export function setQueryParam(source: string, key: string, value: string) {
  const [head, tl] = source.split("?");
  console.log(head);
  console.log("tl : ", tl);
  const params = getQueryParams(tl);
  console.log("params : ", params);
  params[key] = value;
  console.log("params : ", params);
  const v = [];
  for (const k in params) {
    console.log("k in loop : ", k);
    v.push({ k, v: params[k] });
  }
  console.log("v", v);
  return (
    head +
    "?" +
    v.reduce((acc, val, index) => {
      console.log(val.k);
      acc += `${val.k}=${encodeURIComponent(val.v)}${
        index < v.length - 1 ? "&" : ""
      }`;
      return acc;
    }, "")
  );
}
